module.exports = __webpack_public_path__ + "static/media/m_sf_1.873532ba.png";